import { SCORM_CONFIG_MIGRATION } from './scorm-migrator.config';

export class ScormMigratorService {
  static initMigration(scormData: any): any {
    if (!SCORM_CONFIG_MIGRATION.length) {
      return scormData;
    }

    let currentVersion = scormData.version;
    if (!currentVersion) {
      currentVersion = SCORM_CONFIG_MIGRATION[0].from;
    }
    let migrator = SCORM_CONFIG_MIGRATION.find(m => m.from === currentVersion);
    while (migrator) {
      currentVersion = scormData.version;
      scormData = migrator.function(scormData);
      scormData.version = migrator.to;
      migrator = SCORM_CONFIG_MIGRATION.find(m => m.from === migrator.to);
    }

    return scormData;
  }
}
